export default __webpack_public_path__ + "images/752974a766936016aaf93d923f9c6c2d.svg";